export class Category {
    private id: number;
    public get _id(): number {
        return this.id;
    }
    public set _id(value: number) {
        this.id = value;
    }
    private description: string;
    public get _description(): string {
        return this.description;
    }
    public set _description(value: string) {
        this.description = value;
    }
}